/**
 * SYNAPZ Degen Asset Manifest
 *
 * Ten approved PNG files. Every component must import image paths from here.
 * Do NOT guess filenames. Do NOT substitute CSS/SVG art. Do NOT use anonymous references.
 * All files live in: public/assets/synapz-degen/
 */
export const degenAssets = {
  /** Homepage hero — neon city skyline, rocket, Robinhood/Base/Solana portals, lightning storm */
  hero:      "/assets/synapz-degen/neon_city_under_a_stormy_sky.png",
  /** AI Launch Studio — hooded mascot figure in neon storm */
  mascot:    "/assets/synapz-degen/mysterious_figure_in_neon_storm.png",
  /** Create / Launch — futuristic rocket with neon energy bursts */
  rocket:    "/assets/synapz-degen/futuristic_rocket_with_neon_energy_bursts.png",
  /** Robinhood Chain card — futuristic Robinhood UI panel */
  robinhood: "/assets/synapz-degen/futuristic_robinhood_ui_panel.png",
  /** Base card — futuristic neon glow interface */
  base:      "/assets/synapz-degen/base_interface_with_futuristic_neon_glow.png",
  /** Solana card — futuristic Solana status card */
  solana:    "/assets/synapz-degen/futuristic_solana_status_card_design.png",
  /** System terminal — cyberpunk terminal interface */
  terminal:  "/assets/synapz-degen/futuristic_cyberpunk_terminal_interface.png",
  /** Market intelligence — crypto token dashboard card (illustrative) */
  market:    "/assets/synapz-degen/futuristic_crypto_token_dashboard_card.png",
  /** Trading experience — crypto trading interface design (illustrative) */
  trading:   "/assets/synapz-degen/futuristic_crypto_trading_interface_design.png",
  /** Platform capabilities strip — full-width neon UI dashboard display */
  features:  "/assets/synapz-degen/futuristic_neon_ui_dashboard_display.png",
} as const;
